import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { validateAndClearExpiredToken } from "../utils/tokenUtils";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user: authUser } = useSelector(state => state.auth);
  const { currentUser } = useSelector(state => state.user);
  
  // Validate token and clear if expired
  const hasValidToken = validateAndClearExpiredToken();
  const userData = sessionStorage.getItem("user");
  
  // Check if user is authenticated with valid token
  const isUserAuthenticated = isAuthenticated && 
    hasValidToken && 
    userData && 
    (authUser || currentUser);
  
  return isUserAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
